import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import styles from './listing-filter-section.module.scss';
interface ListingFilterSectionProps {
  children: ReactNode;
  title: string;
}
export default function ListingFilterSection(props) {
  const $ = _c(5);
  const {
    children,
    title
  } = props;
  let t0;
  if ($[0] !== title) {
    t0 = <div className={styles.filterSection_title}>{title}</div>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== children || $[3] !== t0) {
    t1 = <div className={styles.filterSection}>{t0}{children}</div>;
    $[2] = children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}